"use client";

import { useState } from "react";
import Image from "next/image";
import {
	RenderImageContext,
	RenderImageProps,
	RowsPhotoAlbum,
} from "react-photo-album";
import "react-photo-album/rows.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
// import "yet-another-react-lightbox/plugins/zoom.css";
import "yet-another-react-lightbox/plugins/captions.css";

import type { Photo } from "react-photo-album";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { IMedia } from "@/types/strapi";
import { getImageUrl } from "@/utils/images";
import { Eye } from "lucide-react";

// ---------- renderNextImage ----------

function renderNextImage(
	{ alt = "", title, sizes }: RenderImageProps,
	{ photo }: RenderImageContext
) {
	return (
		<div className="relative w-full h-[200px] group overflow-hidden rounded-xl">
			<Image
				fill
				src={getImageUrl(photo.src)}
				alt={alt}
				title={title}
				sizes={sizes}
				className="object-cover object-top transition-all duration-300 group-hover:scale-105"
			/>

			{/* Overlay */}
			<div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
				<div className="h-10 w-10 flex items-center justify-center rounded-full bg-white/80 backdrop-blur-sm text-black">
					<Eye />
				</div>
			</div>
		</div>
	);
}

// ---------- Gallery ----------
export default function Gallery({ photosStrapi }: { photosStrapi: IMedia[] }) {
	const [index, setIndex] = useState(-1);
	const photos: Photo[] = photosStrapi.map((m) => ({
		src: m.formats?.medium?.url ?? m.url, // obligatoire
		width: m.width,
		height: m.height,
		alt: m.alternativeText ?? "",
		caption: m.caption ?? "",
		alternativeText: m.alternativeText ?? "",
	}));

	const slides = photosStrapi.map((p) => ({
		src: getImageUrl(p.formats?.large?.url ?? p.url),
		description: p.caption || p.alternativeText || p.name || "",
	}));

	return (
		<>
			<RowsPhotoAlbum
				photos={photos}
				onClick={({ index }) => setIndex(index)}
				render={{ image: renderNextImage }}
				targetRowHeight={120} // ← modifie la hauteur
				defaultContainerWidth={1200}
				sizes={{
					size: "1168px",
					sizes: [
						{
							viewport: "(max-width: 1200px)",
							size: "calc(100vw - 32px)",
						},
					],
				}}
			/>

			<Lightbox
				open={index >= 0}
				index={index}
				close={() => setIndex(-1)}
				slides={slides}
				plugins={[Zoom, Captions]}
				captions={{ descriptionTextAlign: "center" }}
				zoom={{
					maxZoomPixelRatio: 3, // zoom ×3
					zoomInMultiplier: 1.5,
					doubleTapDelay: 300,
					doubleClickDelay: 300,
				}}
			/>
		</>
	);
}
